<script setup lang="ts">
    import { SplideSlide } from '@splidejs/vue-splide';

    const props = defineProps<{ blok: FachkreisProductSliderStoryblok }>();

    const { t } = useI18n();

    const sliderOptions = computed(() => {
        return {
            perPage: 4,
            rewind: true,
            rewindByDrag: true,
            gap: '1rem',
            drag: props.blok.products?.length > 4,
            arrows: props.blok.products && props.blok.products?.length > 4,
            breakpoints: {
                1024: {
                    perPage: 2,
                    arrows: props.blok.products && props.blok.products?.length > 2
                },
                640: {
                    perPage: 1,
                    arrows: props.blok.products && props.blok.products?.length > 1
                }
            }
        };
    });
</script>

<template>
    <div class="crossselling-container">
        <div class="title">
            <StoryblokComponentWrapper
                v-for="item in props.blok.Headline"
                :key="item._uid"
                :blok="item"
            />

            <PrimaryButton
                v-if="blok.allProductsLink"
                :button-href="useStoryblokUrl(props.blok.allProductsLink)"
                :button-text="t('listing.allProducts')"
                variant="secondary"
                size="small"
            />
        </div>

        <LazySliderComponent :options="sliderOptions">
            <template #slides>
                <SplideSlide
                    v-for="product in props.blok.products"
                    :key="product"
                    class="slide"
                >
                    <StoryblokComponentWrapper :blok="product" />
                </SplideSlide>
            </template>
        </LazySliderComponent>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/detail-page/crossselling-slider.scss';
</style>
